import {Component, Input, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UnsubscriberComponent } from 'src/app/components/shared/unsubscriber.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AnprRecord, DuplicateVehicleInformation, VehicleInformation, VehicleInformationService } from '../../../../pages/workorders/vehicle-information.service';
import { CardListCell } from '../../card-list/card-list-cell';
import { CardListCellTypes } from '../../card-list/card-list-cell-types.enum';
import { AddAnprRecordDialogComponent } from '../add-anpr-record-dialog/add-anpr-record-dialog.component';
import { ConfirmDialogComponent } from '../../Dialogs/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'vehicle-info',
    templateUrl: './vehicle-info.component.html',
    styleUrls: ['./vehicle-info.component.scss'],
    providers: [TranslatePipe],
    standalone: false
})
export class VehicleInfoComponent extends UnsubscriberComponent implements OnInit {
  @Input() public googleLookups: string[];
  @Input() public formClass = '';
  @Input() public cardClass = '';
  
  private _npId: string = null;
  @Input() set npId(newNpId: string) {
    this.clear();
    this._npId = newNpId;
    if(!!newNpId) {
      this.loadVehicleInfo(newNpId);
    }
  }
  get npId(): string {
    return this._npId;
  }

  @Input() public showClaimCount: boolean;
  @Input() public showGoogleSearch: boolean;
  @Input() public enableCorrections: boolean = false;
  public vehicleDetail: VehicleInformation;
  public anprRecords: AnprRecord[] = [];
    public otherAnprRecords: AnprRecord[];
    public currentAnprRecords: AnprRecord[];

  public googleLookup: string;
  public additionalInfo: DuplicateVehicleInformation[];
    public isLoading: boolean;
    public isAnprLoading: boolean;


  constructor(
    private vehicleinfoService: VehicleInformationService,
    private dialog: MatDialog,
    private toastrService: ToastrService,
    private translatePipe: TranslatePipe
    ) {
    super();
  }

  ngOnInit() {
  }

  public anprTableProps: CardListCell[] = [
    {
      title: '',
          textResolver: (item: AnprRecord) => item.npId + (item.info === '' ? '' : ' > ' + item.info),
          class: 'text-truncate dashb-cell npid text-small text-muted',
      type: CardListCellTypes.text,
    },
    {
      title: '',
      textResolver: (item: AnprRecord) => item.count.toString(),
      class: 'text-truncate dashb-cell text-small text-muted vehicle-info-number',
      type: CardListCellTypes.text,
    },
    
    {
      title: '',
      textResolver: (item: AnprRecord) => item.anpRecordType,
      classResolver: (item: AnprRecord) => this.classResolver(item),
      type: (_) => this.enableCorrections ? CardListCellTypes.link : CardListCellTypes.text,
      linkHandler: (item: AnprRecord) => this.removeAnprRecord(item),
    }
  ];
    
  public additionalInfoTableProps: CardListCell[] = [
    {
      title: '',
      textResolver: (item: DuplicateVehicleInformation) => item.npId,
      class: 'text-truncate text-small dashb-cell',
      type: (item: DuplicateVehicleInformation) => !!item?.vehicleId ? CardListCellTypes.link : CardListCellTypes.text,
      linkHandler: (item: DuplicateVehicleInformation) => this.openClaim(item?.vehicleId),
    },
    {
      title: '',
      textResolver: (item: DuplicateVehicleInformation) => item.count.toString(),
      class: 'text-truncate text-small text-muted dashb-cell vehicle-info-number',
      type: CardListCellTypes.text,
    },
    {
      title: '',
      textResolver: (item: DuplicateVehicleInformation) => item.countPaid.toString(),
      class: 'text-truncate text-small text-success dashb-cell vehicle-info-number',
      type: CardListCellTypes.text,
    },
    {
      title: '',
      textResolver: (item: DuplicateVehicleInformation) => item.countCanceled.toString(),
      class: 'text-truncate text-small text-danger dashb-cell vehicle-info-number',
      type: CardListCellTypes.text,
    },
  ];

    private loadVehicleInfo(npId: string, useCache: boolean = true) {
    this.isLoading = true;
    this.isAnprLoading = true;
    this.clear();

    this.vehicleinfoService.getVehicleClassFromNpId(npId).subscribe(vehicleDetailInfo => {
      if (!!vehicleDetailInfo) {
        this.vehicleDetail = vehicleDetailInfo;
        this.googleLookup = `https://www.google.com/search?q=${vehicleDetailInfo.brand}+${vehicleDetailInfo.model}&tbm=isch`;
      }
    },
    err => console.error(err),
    () => this.isLoading = false
    );

    this.vehicleinfoService.getVehicleClaimDataFromNpId(npId).subscribe(vehicleAdditionalInfo => {
      if (!!vehicleAdditionalInfo) this.additionalInfo = vehicleAdditionalInfo;
    });

        this.vehicleinfoService.getAnprRecordsByVrm(npId.substring(3, npId.length), useCache).subscribe((records: AnprRecord[]) => {
        this.anprRecords = records;
        this.currentAnprRecords = this.anprRecords.filter(x => x.npId === this.npId);
        this.otherAnprRecords = this.anprRecords.filter(x => x.npId !== this.npId);
        this.isAnprLoading = false;
    });

  }

  private clear() {
    this.vehicleDetail = null;
    this.additionalInfo = null;
    this.googleLookup = `https://www.google.com`;
  }

  public openGoogle(searchLink: string) {
    if (this.showGoogleSearch)
      window.open(searchLink, '_blank', 'fullscreen=yes');
  }

  public openClaim(vehicleId: string) {
    if (this.showClaimCount)
      window.open('https://bo-stage.epass24.com/claims/vehicle/' + vehicleId, '_blank', 'width=1740,height=920,resizable,scrollbars=yes,status=1');
  }


    private classResolver(item: AnprRecord) {

        switch (item.anpRecordType) {
            case "APPROVED":
                return "text-truncate dashb-cell text-icon-success";
            case "INFO":
                return "text-truncate dashb-cell text-icon-alert";
            case "COUNTRY_CHANGE":
                return "text-truncate dashb-cell text-icon-danger";
            case "EPASS24_ACCOUNT":
                return "text-truncate dashb-cell text-icon-epass24";
            case "ENVIRONMENT_REG":
                return "text-truncate dashb-cell text-icon-envreg";
            default:
                return "text-truncate dashb-cell text-icon-danger";
        }

        //(
        //return 'text-truncate dashb-cell ' + ((item.anpRecordType == "COUNTRY_CHANGE") ? 'text-icon-danger' :
        //    (item.anpRecordType == "APPROVED") ? 'text-icon-success' : 'text-icon-danger')
    }

  public addAnprRecord() {
    if(this.enableCorrections) {
      this.dialog.open(
        AddAnprRecordDialogComponent,
        {
          disableClose: true,
          autoFocus: false,
          position: { top: '100px' },
          // width: '640px',
          data:
          {
            npId: this.npId
          }
        }
      ).afterClosed().subscribe(result => {        
          this.currentAnprRecords = null;
          this.otherAnprRecords = null;
          this.loadVehicleInfo(this.npId, false);
      });
    }
  }

  private removeAnprRecord(item: AnprRecord) {
    if(this.enableCorrections) {
      this.dialog.open(
        ConfirmDialogComponent,
        {
          disableClose: true,
          autoFocus: false,
          position: { top: '100px' },
          width: '480px',
          data:
          {
            title: 'Confirm Delete',
            text: `You're about to delete [ ${item.anpRecordType} ] ANPR record for [ ${item.npId} ] is that correct?`,
            okText: 'Yes',
            cancelText: 'No'
          }
        }
      ).afterClosed().subscribe(result => {
        if (!!result) {
          this.vehicleinfoService.deleteAnprRecord(item.anprRecordId).subscribe(
              _ => {
                  this.currentAnprRecords = null;
                  this.otherAnprRecords = null;
                  this.loadVehicleInfo(this.npId, false);
                  this.toastrService.success(this.translatePipe.transform('BO_SUCCESS'));
            },
            err => {
                this.currentAnprRecords = null;
                this.otherAnprRecords = null;
              this.loadVehicleInfo(this.npId, false);
              this.toastrService.error(this.translatePipe.transform('BO_FAILED'));
            },
            () => {} // Todo: refresh view?
          );
        }
      });
    }
  }
}
